let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = Promise.all([load("lwKXH"), load("4byV5")]).then(() => parcelRequire('3f9PV'));